import { Modal, Icon, Text, CopyToClipboard } from '@intellecteu/common-ui';
import { InfoCardItem } from '../../ui';
import { CopyText } from '../../copy-text';

import s from './styles.module.scss';

interface CopyUserDataModalProps {
  onSubmit: () => void;
  username: string;
  password: string | null;
}

export const CopyUserDataModal = ({ onSubmit, username, password = null }: CopyUserDataModalProps) => (
  <Modal
    withConfirm
    className={s.copyModal}
    footerClassName={s.copyModalFooter}
    onSubmit={onSubmit}
    submitText="Copy and close"
    onClose={() => {}}
    cancelText=""
  >
    <div className={s.copyModalContent}>
      {password ? (
        <>
          <div className={s.copyModalContentHeader}>
            <Icon icon={Icon.icons.error} color="error" />
            <Text weight="bold">Copy user data</Text>
          </div>

          <Text color={Text.color.darkBlue}>
            Please note: it is essential that you copy created keycloak user data because it won’t be possible to see
            this data afterwards.
          </Text>

          <div>
            <InfoCardItem title="Username" value={<CopyText value={username} />} />

            <Text color={Text.color.darkGrey}>Temporary password:</Text>
            <CopyToClipboard value={password} />
          </div>
        </>
      ) : (
        <>
          <div className={s.copyModalContentHeader}>
            <Icon icon={Icon.icons.info} color="darkBlue" />
            <Text weight="bold">User is configured for this validator.</Text>
          </div>

          <InfoCardItem title="Username" value={<CopyText value={username} />} />
        </>
      )}
    </div>
  </Modal>
);
